export const FEATURE_EXAMPLE = 'ppark-xxxx-example-feature';
